module.exports = __webpack_public_path__ + "img/rehab-icon.71e57825.svg";